import http from 'hub-http/clients/apiClient';
export const fetchUsersForInbox = ({
  inboxId,
  agentIds = []
}) => {
  return http.put(`/messages/v2/users/inbox/${inboxId}`, {
    data: agentIds
  });
};